import { Grid2, Typography } from "@mui/material";
import { OcRoleFilterSwitchItemProps } from "./role-filter-switch-item";
import { OcFormSwitch } from "oc/components/form-switch";

export const OcRoleFilterSwitchItemView = ({
  label,
  selected,
  disabled,
  handleSwitchChange,
}: OcRoleFilterSwitchItemProps) => (
  <>
    <Grid2
      size={6}
      sx={{
        justifyContent: "right",
        display: "flex",
        alignItems: "center",
        height: "23px",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: "flex",
          textAlign: "end",
        }}
      >
        {label}
      </Typography>
    </Grid2>
    <Grid2
      sx={{
        display: "flex",
        alignItems: "center",
        height: "23px",
      }}
    >
      <OcFormSwitch
        id={`switch-${label}`}
        checked={selected}
        disabled={disabled}
        onChange={handleSwitchChange}
      />
    </Grid2>
  </>
);
